var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small"},[_c('income-chart',{staticStyle:{"background":"#1F222A","padding":"7px","color":"#fff"},attrs:{"height":300,"chart-data":_vm.CHARTDATA,"dark":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }